"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-muted-light animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-muted-light animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-muted-light animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-row gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-foreground hover:text-primary transition-colors duration-[var(--duration-medium)] relative after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  return <footer className="w-full bg-background border-t border-border shadow-soft">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/nethill_limited_footer_logo.png" alt="Nethill Limited" className="h-7" />
          </div>

          <MenuProvider menu_id="14" className="footer-navigation">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>
      </div>
    </footer>;
}